export default [
    {
        path: 'status',
        component: () => import(
            /* webpackChunkName: 'regulacao-status' */
            '@/views/regulacao/status/Index'
        ),
        redirect: 'status/index',
        children: [
            {
                name: 'regulacao-status-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'regulacao-status' */
                    '@/views/regulacao/status/List.vue'
                ),
            },
            {
                name: 'regulacao-status-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'regulacao-status' */
                    '@/views/regulacao/status/Form.vue'
                ),
            },
            {
                name: 'regulacao-status-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'regulacao-status' */
                    '@/views/regulacao/status/Form.vue'
                ),
            },
        ],
    },
]